var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { dinapsisModalSliderPanel } from './dinapsis-modal-slider-panel-style';
import { dinapsisLateralSliderPanel } from '../lateral-slider-panel/dinapsis-lateral-slider-panel-style';
/**
 * Represents the modal-slider-panel that open or close a div on the side
 */
let DinapsisModalSliderPanel = class DinapsisModalSliderPanel extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Setting the default value of the property `width` to `294px`.
         * Define the width of the panel
         */
        this.width = '40vw';
        /**
         * Setting the default value of the property `height` to `calc(100vh - 52px)`.
         * Define the Height of the panel
         */
        this.height = 'calc(100vh - 52px)';
        /**
         * Setting the default value of the property `position` to left
         */
        this.position = 'right';
        /**
         * Setting the default value of the property `classes` to `{ hide: true, active: false }`.
         */
        this.classes = { hide: true, active: false };
        /**
         * Set model with configuration
         */
        this.model = {
            opened: false,
            header: {
                title: '',
                subtitle: '',
                iconTitle: '',
            },
            isModal: true,
        };
    }
    /**
     * If the container is active, then set the width to 0px and hide it.
     * Otherwise, set the width and height to the width
     * and height properties and make it active.
     */
    handleClick() {
        var _a;
        this.model = { ...this.model, opened: !this.model.opened };
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-modal-slider-container');
        if (container) {
            if (container.className.includes('active')) {
                container.style.width = '0px';
                container.className = 'hide';
            }
            else {
                container.style.width = this.width;
                container.className = 'active';
            }
        }
    }
    /**
     * If the panel is on the left and is not opened,
     * return the left panel class. If the panel is on the
     * left and is opened, return the left panel active class.
     * If the panel is on the right and is not opened,
     * return the right panel class.
     * If the panel is on the right and is opened, return the right
     * panel active class.
     * @returns The result of the function is a string.
     */
    getPanelStyle() {
        var _a;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-modal-slider-container');
        if (container)
            container.style.height = this.height;
        if (this.position === 'left' && !this.model.opened) {
            if (container)
                container.style.width = '0px';
            return 'left-panel';
        }
        if (this.position === 'left' && this.model.opened) {
            if (container)
                container.style.width = this.width;
            return 'left-panel-active';
        }
        if (this.position === 'right' && !this.model.opened) {
            if (container)
                container.style.width = '0px';
            return 'right-panel';
        }
        if (this.position === 'right' && this.model.opened) {
            if (container)
                container.style.width = this.width;
            return 'right-panel-active';
        }
        return '';
    }
    setCustomTopMargin() {
        if (this.model.marginTop !== undefined) {
            return `top:${this.model.marginTop}`;
        }
        return '';
    }
    /**
     * It returns a the close button depending on the dinapsis-modal-slider-panel element position.
     * @returns the close button depending on the element position.
     */
    getCloseButton(position) {
        if (this.position === 'left' && position === 'left') {
            return html `
        <div>
          <span class="material-icons-round close-icon" @click="${this.handleClick}">close</span>
        </div>`;
        }
        if (this.position === 'right' && position === 'right') {
            return html `
        <div>
          <span class="material-icons-round close-icon close-icon__right" @click="${this.handleClick}">close</span>
        </div>`;
        }
        return '';
    }
    /**
     * It returns the dinapsis-modal-slider-panel header icon.
     * @returns the header icon.
     */
    getHeaderIcon() {
        if (this.model.header.iconTitle) {
            return html `
        <span class="material-icons-round header-icon">${this.model.header.iconTitle}</span>`;
        }
        return '';
    }
    /**
     * It returns the dinapsis-modal-slider-panel header subtitle.
     * @returns the header subtitle.
     */
    getHeaderSubtitle() {
        if (this.model.header.subtitle) {
            return html `
        <span class="subtitle subtitle__${this.position}">${this.model.header.subtitle}</span>`;
        }
        return '';
    }
    clickModalSlider(event) {
        var _a;
        const divModal = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('modal-slider-panel');
        if (event.target === divModal && this.model.opened) {
            this.handleClick();
        }
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        var _a;
        if (changedProperties.has('model')) {
            const divModal = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('modal-slider-panel');
            if (divModal && this.model.isModal) {
                if (this.model.opened) {
                    divModal.classList.add('activated-modal-slider-panel');
                }
                else {
                    divModal.classList.remove('activated-modal-slider-panel');
                }
            }
            // Dispatch event change model
            this.dispatchEvent(new CustomEvent('change-model', { detail: this.model }));
        }
    }
    /**
     * The above function is a lifecycle hook that is called when the component is first updated.
     */
    firstUpdated() {
        var _a;
        const container = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('dinapsis-modal-slider-container');
        if (container && !this.model.opened) {
            container.style.width = '0px';
            container.className = 'hide';
        }
    }
    /**
     * If the panel is opened, then the panel is not hidden and is active.
     * @returns The html template is being returned.
     */
    render() {
        if (this.model.opened) {
            this.classes.hide = false;
            this.classes.active = true;
        }
        else {
            this.classes.hide = true;
            this.classes.active = false;
        }
        return html `
      <div id="modal-slider-panel" @click=${this.clickModalSlider}>
      </div>
        <div id="modal-slider-panel-container" class="${this.getPanelStyle()}" style="${this.setCustomTopMargin()}">
          <div style="width:${this.width}; height:${this.height};" class=${classMap(this.classes)} id="dinapsis-modal-slider-container">
            <div class="header-container">
              ${this.getCloseButton('right')}
              <div class="title-container">
                ${this.getHeaderIcon()}
                <span class="title">${this.model.header.title}</span>
                ${this.getHeaderSubtitle()}
              </div>
              ${this.getCloseButton('left')}
            </div>
            <slot></slot>            
          </div>
        </div>
      `;
    }
};
/**
 * A CSS style sheet.
 */
DinapsisModalSliderPanel.styles = [dinapsisLateralSliderPanel, dinapsisModalSliderPanel];
__decorate([
    property({ type: String })
], DinapsisModalSliderPanel.prototype, "width", void 0);
__decorate([
    property({ type: String })
], DinapsisModalSliderPanel.prototype, "height", void 0);
__decorate([
    property({ type: String })
], DinapsisModalSliderPanel.prototype, "position", void 0);
__decorate([
    property()
], DinapsisModalSliderPanel.prototype, "classes", void 0);
__decorate([
    property({ type: Object })
], DinapsisModalSliderPanel.prototype, "model", void 0);
DinapsisModalSliderPanel = __decorate([
    customElement('dinapsis-modal-slider-panel')
], DinapsisModalSliderPanel);
export { DinapsisModalSliderPanel };
//# sourceMappingURL=dinapsis-modal-slider-panel.js.map